import React from 'react';

import { IStore } from '~/src/dash/reducers/store';
import {
  IHistoryProps,
  IReduxActionProps,
  ISessionStateProps,
  IWithStylesProps,
} from '~/src/dash/types/props';
import { decorate } from '~/src/dash/utils/decorator';
import { IPTraceSettingForm } from '~/src/dash/views/ip-trace/ip-trace-setting-form';

interface IProps extends IWithStylesProps, IReduxActionProps, ISessionStateProps, IHistoryProps {}

export const IPTraceNewView = decorate(
  {
    redux: (state: IStore) => {
      return {
        session: state.session,
      };
    },
  },
  function ({ session }: IProps) {
    return (
      <div>
        <IPTraceSettingForm
          ipTrace={{
            ID: '',
            UUID: '',
            CreatedAt: '',

            PublisherID: session.publisher.ID,
            IP: '',
            Email: '',
            TimeFrame: '',
          }}
        />
      </div>
    );
  },
);
